import React from "react";
import { NavLink } from "react-router-dom";
export default class CustomLink extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            to = "/",
            key = "0",
            style = {},
            activeStyle = {},
            activeClassName = ""
        } = this.props;
        return (
            <NavLink
                {...this.props}
                to={to}
                key={key}
                style={Object.assign({}, style)}
                activeStyle={Object.assign({}, activeStyle)}
                activeClassName={activeClassName}
            />
        );
    }
}
